"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _I18n = _interopRequireDefault(require("I18n"));

var _reduce = _interopRequireDefault(require("transmute/reduce"));

var _TimeRange = _interopRequireDefault(require("MeetingsBase/models/TimeRange"));

var _TimeRangeListUtils = require("MeetingsBase/utils/TimeRangeListUtils");

var _dates = require("MeetingsBase/utils/dates");

var _dates2 = require("MeetingsBase/constants/dates");

var defaults = (0, _reduce.default)({}, function (accumulator, day) {
  return (0, _extends3.default)({}, accumulator, (0, _defineProperty2.default)({}, day, (0, _immutable.List)()));
}, _dates2.AVAILABILITY_OPTIONS);

var Availability =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(Availability, _Record);

  function Availability() {
    (0, _classCallCheck2.default)(this, Availability);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Availability).apply(this, arguments));
  }

  (0, _createClass2.default)(Availability, [{
    key: "isValid",
    value: function isValid() {
      return this.every(function (timeRanges) {
        return timeRanges.every(function (timeRange) {
          return (0, _dates.validTimeRange)(timeRange);
        });
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.reduce(function (t, a) {
        return t + a.size;
      }, 0) === 0;
    }
  }, {
    key: "getForDateString",
    value: function getForDateString(dateString) {
      var weekDayIndex = _I18n.default.moment(dateString).day();

      return this.getForWeekDayIndex(weekDayIndex);
    }
  }, {
    key: "getUnmergedForWeekDay",
    value: function getUnmergedForWeekDay(weekDay) {
      switch (weekDay) {
        case _dates2.AVAILABLE_DAYS.SATURDAY:
        case _dates2.AVAILABLE_DAYS.SUNDAY:
          return this[weekDay].concat(this[_dates2.AVAILABILITY_OPTIONS.SAT_SUN]).concat(this[_dates2.AVAILABILITY_OPTIONS.EVERY_DAY]);

        case _dates2.AVAILABLE_DAYS.MONDAY:
        case _dates2.AVAILABLE_DAYS.TUESDAY:
        case _dates2.AVAILABLE_DAYS.WEDNESDAY:
        case _dates2.AVAILABLE_DAYS.THURSDAY:
        case _dates2.AVAILABLE_DAYS.FRIDAY:
          return this[weekDay].concat(this[_dates2.AVAILABILITY_OPTIONS.MON_FRI]).concat(this[_dates2.AVAILABILITY_OPTIONS.EVERY_DAY]);

        default:
          return this[weekDay].concat(this[_dates2.AVAILABILITY_OPTIONS.EVERY_DAY]);
      }
    }
  }, {
    key: "getForWeekDayIndex",
    value: function getForWeekDayIndex(index) {
      var weekDay = _dates2.WEEKDAYS_LIST[index];
      var unmergedAvailabilityForWeekDay = this.getUnmergedForWeekDay(weekDay);
      return (0, _TimeRangeListUtils.unify)(unmergedAvailabilityForWeekDay);
    }
  }, {
    key: "setForWeekDayIndex",
    value: function setForWeekDayIndex(availability, index) {
      return this.set(_dates2.WEEKDAYS_LIST[index], availability);
    }
  }], [{
    key: "from",
    value: function from(json) {
      var availability = this._fromWithoutValidation(json);

      return availability.reduce(function (newAvailability, timeRanges, dayKey) {
        newAvailability = newAvailability.set(dayKey, timeRanges.filter(function (timeRange) {
          return (0, _dates.validTimeRange)(timeRange);
        }));
        return newAvailability;
      }, new Availability());
    }
  }, {
    key: "_fromWithoutValidation",
    value: function _fromWithoutValidation(json) {
      if (!json) {
        return new Availability();
      }

      var formattedData = (0, _immutable.Map)(json).map(function (timeRanges) {
        var timeRangesList = !Array.isArray(timeRanges) ? (0, _immutable.Map)(timeRanges).toList() : (0, _immutable.List)(timeRanges);
        return timeRangesList.map(_TimeRange.default.from);
      });
      var sortedAvailability = formattedData.map(function (timeRanges) {
        return timeRanges.sort(function (timeRangeA, timeRangeB) {
          return timeRangeA.end - timeRangeB.end;
        });
      });
      return sortedAvailability;
    }
  }]);
  return Availability;
}((0, _immutable.Record)(defaults));

exports.default = Availability;
module.exports = exports.default;